import { IndexValue } from '../../types/IndexValue';
import { ReqLogin } from '../../rest/models/ReqLogin';
import { ReqOtp } from '../../rest/models/ReqOtp';
import { ReqCanje } from '../../rest/models/ReqCanje';

export const GetLoginPayload = (data: IndexValue, googleToken: string | void) => {
  const i = 1; //formularios indexados para ser leidos en el TemplateForm
  if (data['dni' + i] && data['nombre' + i] && data['email' + i]) {
    return { dni: Number(data['dni' + i]), name: data['nombre' + i], email: data['email' + i], googleToken } as ReqLogin;
  }
};

export const GetOtpPayload = (otpCode: string, token: string | undefined) => {
  return { otpCode: Number(otpCode), token } as ReqOtp;
};

export const GetInvitadosPayload = (data: IndexValue, token: string | undefined, cantMaxima: number) => {
  let invitados: IndexValue[] = [];
  for (let i = 1; i <= cantMaxima; i++) {
    if (data['dni' + i] && data['nombre' + i] && data['email' + i]) {
      invitados.push({ dni: Number(data['dni' + i]), name: data['nombre' + i], email: data['email' + i] });
    }
  }
  return { invitados, token } as ReqCanje;
};
